import {on, find, findIn, addClass, removeClass, findAllIn, findAll, trigger, closest} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init () {

    onFind('.js-multiple-file-input', function (baseElement) {

        const dt = new DataTransfer();
        const multipleFileInput = find('.js-multiple-file-input__input', baseElement);
        const filesList = find('.js-multiple-file-list', baseElement);

       on('change', function(e) {
            for (let i = 0; i < this.files.length; i++) {
                let multipleFileItem = document.createElement('div');
                let name = this.files.item(i).name;
                let size = formatBytes(this.files.item(i).size);
                 multipleFileItem.innerHTML = `<div class="js-multiple-file__item multiple-file__item">
                                                    <div class="d-flex w-100 justify-content-between">
                                                        <div class="js-multiple-file__name multiple-file__name">${name}</div>
                                                        <div class="d-flex align-items-center">
                                                            <div class="multiple-file__size">${size}</div>
                                                            <button type="button" class="js-multiple-file-delete btn btn-no-styling">
                                                                <span class="icon icon-delete"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>`;

                filesList.appendChild(multipleFileItem);
                
            }

            for (let file of this.files) {
                dt.items.add(file);
            }

            this.files = dt.files;
            let deleteBtns = findAll('.js-multiple-file-delete');

            deleteBtns.forEach(function(el) {
                on('click', function() {
                    let item = el.closest('.js-multiple-file__item');
                    let name = findIn('.js-multiple-file__name', item);
                    item.remove();

                    for (let i = 0; i < dt.items.length; i++) {
                        if (name.innerHTML === dt.items[i].getAsFile().name) {
                            dt.items.remove(i);
                            continue;
                        }
                    }

                    multipleFileInput.files = dt.files;
                }, el);
            });
        }, multipleFileInput);

    });
}

function formatBytes(bytes,decimals) {
    var k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
